export const TITLE = 'Single / Group Organization';
export const DESCRIPTION = '';
export const DB_PREFIX = 'admins';
